// Hero Slider

import './index.scss';

import jQuery from 'jquery';
import 'slick-carousel';

export default class HeroSlider {
    constructor(root) {
        this.root = root;
        this.list = jQuery(this.root).find('.list');

        this.length = this.list.find('.item').length;
        this.inited = false;

        this.update();
    }

    update() {
        if (this.length <= 1) { return; }

        if (this.inited) {
            this.inited = false;
            this.list.slick('unslick');
        }

        if (!this.inited) {
            this.inited = true;
            this.list.slick({
                arrows: true,
                appendArrows: '.list-arrows .container',
                prevArrow: '<a href="javascript:;" class="slick-prev slick-arrow"><i class="icon-arrow-left"></i></a>',
                nextArrow: '<a href="javascript:;" class="slick-next slick-arrow"><i class="icon-arrow-right"></i></a>'
            });
        }
    }
}
